import _ from 'lodash';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { getFormattedMemberName } from '@/app/utils/utils';

import BeneficiaryDetails from './details/beneficiary-details.vue';
import WarningUnder25 from './warnings/warning-under-25.vue';
import Warning25AndOver from './warnings/warning-25-and-over.vue';

const initBeneficiary = {
  title: '',
  firstName: '',
  middleName: '',
  lastName: '',
  sex: '',
  dateOfBirth: '',
  relationship: '',
  isMember: false,
  otherRelationship: '',
};

export default {
  name: 'reversionary-beneficiary',
  components: {
    BeneficiaryDetails,
    WarningUnder25,
    Warning25AndOver,
  },
  data() {
    return {
      beneficiaryDetailsValid: false,
    };
  },
  computed: {
    getItem() {
      return _.cloneDeep(this.$store.getters['toolkit/getItemData']);
    },
    pensions() {
      return this.getItem.pensions;
    },
    activePension() {
      return this.getItem.activePension;
    },
    selectedMember() {
      return this.getItem.requirements.member.name;
    },
    eligibleMembers() {
      const { members } = this.$store.getters['fund/getFund'];
      return members.filter(member => getFormattedMemberName(member) !== this.selectedMember);
    },
    formattedEligibleMembers() {
      return this.eligibleMembers.map(member => (getFormattedMemberName(member)));
    },
    hasReversionaryBeneficiary: {
      get() {
        // eslint-disable-next-line max-len
        return this.pensions[this.activePension].reversionaryBeneficiary.hasReversionaryBeneficiary || null;
      },
      set(value) {
        const updateData = {
          reversionaryBeneficiary: {
            hasReversionaryBeneficiary: value,
            hasTrustDeed: this.hasTrustDeed,
            reversionaryBeneficiary: this.reversionaryBeneficiary,
            beneficiaryDetails: this.beneficiaryDetails,
          },
        };
        this.setItem(updateData);
      },
    },
    hasTrustDeed: {
      get() {
        // eslint-disable-next-line max-len
        return this.pensions[this.activePension].reversionaryBeneficiary.hasTrustDeed || null;
      },
      set(value) {
        this.setItem({ reversionaryBeneficiary: { hasTrustDeed: value } });
      },
    },
    reversionaryBeneficiary: {
      get() {
        // eslint-disable-next-line max-len
        return this.pensions[this.activePension].reversionaryBeneficiary.reversionaryBeneficiary || null;
      },
      set(value) {
        this.setItem({ reversionaryBeneficiary: { reversionaryBeneficiary: value } });
      },
    },
    confirmReversionaryBeneficiary: {
      get() {
        // eslint-disable-next-line max-len
        return this.pensions[this.activePension].reversionaryBeneficiary.confirmReversionaryBeneficiary || null;
      },
      set(value) {
        // eslint-disable-next-line max-len
        this.setItem({ reversionaryBeneficiary: { confirmReversionaryBeneficiary: value } });
      },
    },
    beneficiaryDetails() {
      // eslint-disable-next-line max-len
      return this.pensions[this.activePension].reversionaryBeneficiary.beneficiaryDetails || { ...initBeneficiary };
    },
    beneficiaryRelationship() {
      return this.beneficiaryDetails.relationship;
    },
    beneficiaryAgeAtPensionStart() {
      const dateOfBirth = moment(this.beneficiaryDetails.dateOfBirth);
      const pensionStart = moment(this.getItem.requirements.startDate);

      return pensionStart.diff(dateOfBirth, 'years', true);
    },
  },
  mounted() {
    if (this.formattedEligibleMembers.length === 0) {
      this.reversionaryBeneficiary = 'Other';
    }
  },
  methods: {
    setItem(data) {
      _.merge(this.pensions[this.activePension], data);
      this.$store.dispatch('toolkit/updateItemKey', { data: { pensions: this.pensions } });
    },
    handleBackStep() {
      this.$emit('backStep');
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
    handleValid(valid) {
      this.beneficiaryDetailsValid = valid;
    },
  },
  validations() {
    if (this.hasReversionaryBeneficiary === 'Yes') {
      return {
        hasReversionaryBeneficiary: {
          required,
        },
        hasTrustDeed: {
          required,
        },
        reversionaryBeneficiary: {
          required,
        },
        beneficiaryDetails: {
          isValid: (value, vm) => vm.beneficiaryDetailsValid === true,
        },
        confirmReversionaryBeneficiary: {
          isConfirmed: value => value === true,
        },
      };
    }
    return {
      hasReversionaryBeneficiary: {
        required,
      },
    };
  },
};
